import { ReadyState } from 'react-use-websocket';
import clsx from 'clsx';

import { Button } from '@components/Shared';

const suggestions = [
  'How do I create a new project?',
  'What is the difference between clusters?',
  'How to manage my organization settings?',
];

type Props = {
  readyState: ReadyState;
  onSuggestion: (suggestion: string) => void;
};

export const ChatSuggestions: React.FC<Props> = ({
  readyState,
  onSuggestion,
}) => {
  return (
    <li className="mb-8 flex flex-col gap-3">
      <p
        className="animate-message-in text-sm text-neural-03 opacity-0"
        style={{ animationDelay: '0.1s' }}
      >
        Ask me anything about Apolo!
      </p>

      <ul className="flex flex-col flex-wrap justify-center gap-2">
        {suggestions.map((suggestion, index) => (
          <li
            key={suggestion}
            className="animate-message-in opacity-0"
            style={{ animationDelay: `${index * 0.15 + 0.3}s` }}
          >
            <Button
              theme
              disabled={readyState !== ReadyState.OPEN}
              className={clsx(
                'rounded-lg border border-primary-light px-5 py-3 text-left text-neural-06 transition-colors',
                {
                  'cursor-not-allowed opacity-50':
                    readyState !== ReadyState.OPEN,
                  'hover:bg-neural-01': readyState === ReadyState.OPEN,
                },
              )}
              onClick={() => onSuggestion(suggestion)}
            >
              {suggestion}
            </Button>
          </li>
        ))}
      </ul>
    </li>
  );
};
